var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.parent)?_c('div',[_vm._v("\n  "+_vm._s(_vm.translation(_vm.data.parent).name)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }